<lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [data]="data" (passFormEvent)="onFormOutput($event)"></lib-prod-form>
